import { __decorate } from "tslib";
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import { WORKSPACE_SERVICE_URI } from '@workspace/shared/constants/envConfig';
let ApiSpaceTagServiceImpl = class ApiSpaceTagServiceImpl extends PsHttpService {
    get options() {
        return {
            baseURL: `${WORKSPACE_SERVICE_URI}/workspace/web`,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async deleteSpaceTag(data) {
        const res = await this.delete({
            url: `workspace/label/${data.label_id}`,
            data,
        });
        return res.data;
    }
    async createSpaceTag(data) {
        const res = await this.post({
            url: 'workspace/label',
            data,
        });
        return res.data;
    }
    async updateSpaceTag(request) {
        const res = await this.put({
            url: `workspace/label/${request.label_id}`,
            data: _.omit(request, 'label_id'),
        });
        return res.data;
    }
    async querySpaceTags(request) {
        const res = await this.get({
            url: 'workspace/label',
            uuid: `query-space-tags-${request.type}`,
            params: request,
        });
        return res.data;
    }
};
ApiSpaceTagServiceImpl = __decorate([
    injectable()
], ApiSpaceTagServiceImpl);
export { ApiSpaceTagServiceImpl };
